/* eslint-disable no-useless-escape -- Preserve the frozen build58 validation expression. */
// Extracted from frozen iOS58 authValidation.ts.
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PASSWORD_PATTERN =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]).{8,20}$/;
const NICKNAME_PATTERN = /^[가-힣a-zA-Z0-9]{2,14}$/;
export const validateEmail = (email) => EMAIL_PATTERN.test(email.trim());
export const validatePassword = (password) => PASSWORD_PATTERN.test(password);
export const validateNickname = (nickname) => NICKNAME_PATTERN.test(nickname.trim());
export const validateBirthDate = (birthDate) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(birthDate)) return false;
  const [year, month, day] = birthDate.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day &&
    date <= new Date()
  );
};
export const isAtLeastFourteen = (birthDate) => {
  const [year, month, day] = birthDate.split('-').map(Number);
  const today = new Date();
  let age = today.getFullYear() - year;
  if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) {
    age -= 1;
  }
  return age >= 14;
};
export const passwordGuide = '문자, 숫자, 특수문자를 포함한 8~20자를 입력해 주세요.';
